<template>
  <b-badge
    class="state-badge"
    pill
    :class="statusClass"
  >
    {{ status.name }}
  </b-badge>
</template>

<script>
import { PORTION_STATES } from '@/api/resources/entityState/portion-state'

export default {
    name: 'CommonPortionStatusBadge',
    props: {
        status: { type: Object, required: true }
    },
    data() {
        return {
            invalidStatus: { bgColor: 'red', color: 'white', label: 'global.statusOptions.invalid' }
        }
    },
    computed: {
        statusClass() {
            return this.statusOption.class
        },
        statusOption() {
            return Object.values(PORTION_STATES).find((state) => state.code === this.status.code) || this.invalidStatus
        }
    }
}

</script>

<style scoped lang="scss">

.sr-status-badge {
    font-size: font-size(very-tiny) !important;
    font-weight: normal !important;
    min-width: 100px;
}

</style>
